import React, { useEffect, useState } from "react";
import "./Navbar.css";
import LogoImg from "../../../assets/images/FLogo.png";
import moment from "moment";
import { Link } from "react-router-dom";

export const Navbar = () => {
  const [currentTime, setCurrentTime] = useState(moment().format('LTS'));

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTime(moment().format('LTS'));
    }, 1000); // Updates every 1 second

    // Cleanup interval on component unmount
    return () => clearInterval(interval);
  }, []);
  return (
    <div className="bg-[#CAF0F8 border-b border-[#d4d4d4]/60 shadow-sm navbarLinearBg">
      <div className="w-[90%] mx-auto py-2 flex justify-between items-center ">
        <div className="">
          <img src={LogoImg} alt="logo-img" className="w-auto 2xl:h-[5.5vw] xl:h-[5.5vw] lg:h-[5.5vw] md:h-[5.5vw] h-[14vw] " />
        </div>
        <div className="flex justify-center items-center gap-5">
          <p  className="font-mainFont text-white font-[500] 2xl:text-[1.1vw] xl:text-[1.1vw] lg:text-[1.1vw] md:text-[1.1vw] text-[3.1vw] paraColor">{currentTime}</p>
          <p  className="font-mainFont text-white font-[500] 2xl:text-[1.1vw] xl:text-[1.1vw] lg:text-[1.1vw] md:text-[1.1vw] text-[3.1vw] paraColor">{moment().format('LL')}</p>
          
        </div>
      </div>
    </div>
  );
};
